import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Home from './Home'
import StartRide from './StartRide'
import VehicleCode from "./VehicleCode";
import ScannerContainer from "../components/QRScanner/ScannerContainer";
import LoginManager from './Login/LoginManagerSection'
import IncreaseCredit from "./IncreaseCredit";
import Gift from "./Gift";
import Settings from "./Settings";
import Subscription from "./Subscription";
import RoroOrder from "./RoroOrder";
import PurchaseCallback from "./PurchaseCallback";
import Trips from "./Trips";
import Payments from "./Payments";
import TripDetail from "./TripDetail";
import Intro from './Intro'
import RideGuide from './RideGuide';
import FinishGuide from './FinishGuide';
import RideCanceled from './RideCanceled';

export default React.memo(() =>
    <Switch>
        <Route path="/login" component={LoginManager} />
        <Route path="/start" component={StartRide} />
        <Route path="/scanner" component={ScannerContainer} />
        <Route path="/vehicle/id" component={VehicleCode} />
        <Route path="/credit" component={IncreaseCredit} />
        <Route path="/gift" component={Gift} />
        <Route path="/subscription" component={Subscription} />
        <Route path="/setting" component={Settings} />
        <Route path="/order/:id" component={RoroOrder} />
        <Route path="/purchase-callback" component={PurchaseCallback} />
        <Route path="/trips" component={Trips} />
        <Route path="/trip/:id" component={TripDetail}/>
        <Route path="/payments" component={Payments}/>
        <Route path="/intro" component={Intro}/>
        <Route path="/guides/ride" component={RideGuide} />
        <Route path="/guides/finish" component={FinishGuide} />
        <Route path="/guides/cancel" component={RideCanceled} />
        <Route path="/" component={Home} />
    </Switch>)
